<div class="detailed-view-container">
  <button class="back-link-btn" (click)="goToCompany()">
    <span class="material-icons">arrow_back</span>
    {{ origin === 'all-companies' ? 'Back to All companies' : 'Back to Company approval' }}
  </button>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <ng-container *ngIf="companyDetails; else showMessage">
      <div class="company-header-row">
        <div class="company-brand">
          <div class="big-avatar" [style.background-color]="companyDetails.logo_url ? 'transparent' : '#6366f1'">
             <img *ngIf="companyDetails.logo_url" [src]="companyDetails.logo_url" alt="Logo" class="company-logo-img" />
    <span *ngIf="!companyDetails.logo_url">
      {{ companyDetails.company_name.substring(0, 2).toUpperCase() }}
    </span>
          </div>

          <div>
            <div class="title-status-row">
              <h1 class="detailed-company-name">
                {{ companyDetails.company_name }}
              </h1>

              <span
                class="badge-dot"
                [ngClass]="{
                  pending: companyDetails.status === 'pending',
                  approved: companyDetails.status === 'approved',
                  rejected: companyDetails.status === 'rejected',
                  blocked: companyDetails.status === 'blocked',
                  'need-clarification': companyDetails.status === 'need_clarification'
                }"
              >
                <span class="dot"></span>
                {{ companyDetails.status }}
              </span>
            </div>

            <p class="company-meta-subtitle">
              {{ companyDetails.industry }}
              &middot; Joined
              {{ companyDetails.submitted_at | date: "yyyy-MM-dd" }}
            </p>
          </div>
        </div>

        <div class="header-actions" *ngIf="origin !== 'all-companies'">
          <button
            class="btn-action-outline approve"
            *ngIf="companyDetails.status === 'pending'"
            (click)="openApproveModal(companyDetails)"
          >
            Approve
          </button>
          <button
            class="btn-action-outline block"
            *ngIf="companyDetails.status === 'pending' || companyDetails.status === 'approved'"
            (click)="openRejectModal(companyDetails)"
          >
            Reject
          </button>
          <button
            class="btn-action-outline clarification"
            *ngIf="companyDetails.status === 'pending' || companyDetails.status === 'approved'"
            (click)="openClarificationModal(companyDetails)"
          >
            Need Clarification
          </button>
        </div>
      </div>

      <div class="details-grid-layout">
        <div class="details-card">
          <div class="card-top-bar">
            <h2 class="card-section-title">Company Details</h2>

            <!-- <button
              class="edit-btn"
              *ngIf="!isEditingCompany && !['rejected', 'need_clarification', 'need clarification', 'clarification'].includes(companyDetails.status)"
              (click)="editSection('company')"
            >
              <span class="material-icons">edit</span>
              Edit
            </button> -->

            <div class="edit-actions" *ngIf="isEditingCompany">
              <button class="btn-cancel-edit" (click)="cancelEdit('company')">
                Cancel
              </button>

              <button
                class="btn-save-edit"
                (click)="saveSection('company')"
                [disabled]="isSavingCompany"
              >
                <span class="spinner" *ngIf="isSavingCompany"></span>

                {{ isSavingCompany ? "Saving..." : "Save" }}
              </button>
            </div>
          </div>

          <div class="card-grid-fields">
            <div class="grid-field">
              <span class="field-label">COMPANY NAME</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon">domain</span>

                <ng-container *ngIf="!isEditingCompany; else editCompanyName">
                  <span class="field-value">{{ companyDetails.company_name }}</span>
                </ng-container>

                <ng-template #editCompanyName>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.company_name"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">INDUSTRY</span>

              <ng-container *ngIf="!isEditingCompany; else editIndustry">
                <span class="field-value">
                  {{ companyDetails.industry }}
                </span>
              </ng-container>

              <ng-template #editIndustry>
                <input
                  type="text"
                  class="edit-input"
                  [(ngModel)]="companyDetails.industry"
                />
              </ng-template>
            </div>

            <div class="grid-field">
              <span class="field-label">WEBSITE</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon">language</span>

                <ng-container *ngIf="!isEditingCompany; else editWebsite">
                  <a
                    [href]="companyDetails.company_url"
                    target="_blank"
                    class="value-link"
                  >
                    {{ companyDetails.company_url }}
                  </a>
                </ng-container>

                <ng-template #editWebsite>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.company_url"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">LINKEDIN</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon">link</span>

                <ng-container *ngIf="!isEditingCompany; else editLinkedin">
                  <a
                    [href]="companyDetails.linkedin_profile"
                    target="_blank"
                    class="value-link"
                  >
                    {{ companyDetails.linkedin_profile }}
                  </a>
                </ng-container>

                <ng-template #editLinkedin>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.linkedin_profile"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field full-width">
              <span class="field-label">ABOUT COMPANY</span>

              <ng-container *ngIf="!isEditingCompany; else editAbout">
                <span class="field-value">
                  {{ companyDetails.about_company }}
                </span>
              </ng-container>

              <ng-template #editAbout>
                <textarea
                  rows="5"
                  class="edit-textarea"
                  [(ngModel)]="companyDetails.about_company"
                ></textarea>
              </ng-template>
            </div>

            <div class="grid-field full-width">
              <span class="field-label">OFFICE LOCATIONS</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> location_on </span>

                <ng-container *ngIf="!isEditingCompany; else editLocations">
                  <span class="field-value">{{ companyDetails.office_locations.join(", ") }}</span>
                </ng-container>

                <ng-template #editLocations>
                  <input
                    type="text"
                    class="edit-input"
                    [ngModel]="companyDetails.office_locations.join(', ')"
                    (ngModelChange)="onOfficeLocationsChange($event)"
                  />
                </ng-template>
              </span>
            </div>
          </div>
        </div>

        <div class="details-card">
          <div class="card-top-bar">
            <h2 class="card-section-title">Contact Details</h2>

            <!-- <button
              class="edit-btn"
              *ngIf="!isEditingContact && !['rejected', 'need_clarification', 'need clarification', 'clarification'].includes(companyDetails.status)"
              (click)="editSection('contact')"
            >
              <span class="material-icons">edit</span>
              Edit
            </button> -->

            <div class="edit-actions" *ngIf="isEditingContact">
              <button class="btn-cancel-edit" (click)="cancelEdit('contact')">
                Cancel
              </button>

              <button class="btn-save-edit" (click)="saveSection('contact')">
                Save
              </button>
            </div>
          </div>

          <div class="card-grid-fields">
            <div class="grid-field full-width">
              <span class="field-label">OFFICIAL EMAIL</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> mail_outline </span>

                <ng-container *ngIf="!isEditingContact; else editOfficialEmail">
                  <span class="field-value">{{ companyDetails.contact.official_email }}</span>
                </ng-container>

                <ng-template #editOfficialEmail>
                  <input
                    type="email"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.official_email"
                  />
                </ng-template>
              </span>
            </div>
            <div class="grid-field">
              <span class="field-label">POINT OF CONTACT</span>
              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> person_outline </span>
                <ng-container *ngIf="!isEditingContact; else editPocName">
                  <span class="field-value">{{ companyDetails.contact.poc_name }}</span>
                </ng-container>

                <ng-template #editPocName>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.poc_name"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">POC EMAIL</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> mail_outline </span>

                <ng-container *ngIf="!isEditingContact; else editPocEmail">
                  <span class="field-value">{{ companyDetails.contact.poc_email }}</span>
                </ng-container>

                <ng-template #editPocEmail>
                  <input
                    type="email"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.poc_email"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">POC MOBILE</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon">phone</span>

                <ng-container *ngIf="!isEditingContact; else editPocPhone">
                  <span class="field-value">{{ companyDetails.contact.poc_phone }}</span>
                </ng-container>

                <ng-template #editPocPhone>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.poc_phone"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">HR NAME</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> person_outline </span>

                <ng-container *ngIf="!isEditingContact; else editHrName">
                  <span class="field-value">{{ companyDetails.contact.hr_name }}</span>
                </ng-container>

                <ng-template #editHrName>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.hr_name"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">HR EMAIL</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon"> mail_outline </span>

                <ng-container *ngIf="!isEditingContact; else editHrEmail">
                  <span class="field-value">{{ companyDetails.contact.hr_email }}</span>
                </ng-container>

                <ng-template #editHrEmail>
                  <input
                    type="email"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.hr_email"
                  />
                </ng-template>
              </span>
            </div>

            <div class="grid-field">
              <span class="field-label">HR PHONE</span>

              <span class="field-value-with-icon">
                <span class="material-icons field-icon">phone</span>

                <ng-container *ngIf="!isEditingContact; else editHrPhone">
                  <span class="field-value">{{ companyDetails.contact.hr_phone }}</span>
                </ng-container>

                <ng-template #editHrPhone>
                  <input
                    type="text"
                    class="edit-input"
                    [(ngModel)]="companyDetails.contact.hr_phone"
                  />
                </ng-template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #showMessage>
      <p class="text-center mt-5">No company details found</p>
    </ng-template>
  </ng-template>
</div>

<div class="modal-backdrop" *ngIf="showApproveModal">
  <div class="modal-card" *ngIf="companyDetails">
    <button class="modal-close-btn" (click)="closeApproveModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Approve {{ companyDetails.company_name }}?</h2>
    <p class="modal-body">
      They will be able to post jobs and access the company dashboard. An
      approval email will be sent to
      <span class="highlight">{{ companyDetails.contact.poc_email }}</span
      >.
    </p>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeApproveModal()">Cancel</button>
      <button
        class="btn-confirm-approve"
        (click)="confirmApproval()"
        [disabled]="isApprovalLoading"
      >
        {{ isApprovalLoading ? "Approving..." : "Confirm approval" }}
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showRejectModal">
  <div class="modal-card" *ngIf="companyDetails">
    <button class="modal-close-btn" (click)="closeRejectModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Reject {{ companyDetails.company_name }}</h2>
    <p class="modal-body">
      Your message will be emailed to
      <span class="highlight">{{ companyDetails.contact.poc_email }}</span
      >.
    </p>
    <div class="form-group">
      <label class="form-label">Reason for rejection</label>
      <textarea
        class="form-textarea"
        rows="4"
        placeholder="Share why this company isn't a fit right now..."
        [(ngModel)]="rejectionReason"
      >
      </textarea>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeRejectModal()">Cancel</button>
      <button
        class="btn-confirm-reject"
        (click)="confirmRejection()"
        [disabled]="isApprovalLoading || !rejectionReason || rejectionReason.trim().length < 5"
      >
        {{ isApprovalLoading ? "Rejecting..." : "Send rejection" }}
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showClarificationModal">
  <div class="modal-card" *ngIf="companyDetails">
    <button class="modal-close-btn" (click)="closeClarificationModal()">
      <span class="material-icons">close</span>
    </button>
    <h2 class="modal-title">Request Clarification from {{ companyDetails.company_name }}</h2>
    <p class="modal-body">
      Your clarification request will be emailed to
      <span class="highlight">{{ companyDetails.contact.poc_email }}</span>.
    </p>
    <div class="form-group">
      <label class="form-label">Clarification required details</label>
      <textarea
        class="form-textarea"
        rows="4"
        placeholder="Specify what clarification is needed from this company..."
        [(ngModel)]="clarificationReason"
      >
      </textarea>
    </div>
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeClarificationModal()">Cancel</button>
      <button
        class="btn-confirm-reject"
        (click)="confirmClarification()"
        [disabled]="isApprovalLoading || !clarificationReason || clarificationReason.trim().length < 5"
      >
        {{ isApprovalLoading ? "Sending..." : "Send request" }}
      </button>
    </div>
  </div>
</div>
